import { initDayjs } from './dayjs';
import { initAgGrid } from './ag-grid';
import { initGleap } from './gleap';
import { initApiClient } from './api';
import { initSentry } from './sentry';
import { initReactMUI } from './react-mui';

export { useTranslation } from './i18n/useTranslate';

export function initLibs() {
  initApiClient();
  initAgGrid();
  initDayjs();
  initGleap();
  initSentry();
  initReactMUI();
}
